// @flow
// $FlowFixMe
import React, {Suspense} from 'react';
import {ErrorReportBoundary} from '@homeaway/react-error-reporter';

// $FlowFixMe
const LEX = React.lazy(
    /* istanbul ignore next */ () =>
        import(/* webpackChunkName: "react-lex" */ '@homeaway/react-lex')
);

// $FlowFixMe props are any react-lex props
export default function LoginExperience(props) {
    return (
        <Suspense fallback={null}>
            <ErrorReportBoundary name={'there was an error in react-lex'}>
                <LEX {...props} />
            </ErrorReportBoundary>
        </Suspense>
    );
}
